export default "__VITE_ASSET__651de530__"